require("./src/style/reset.css")
require("./src/style/prism-original.css")
require(`katex/dist/katex.min.css`)